//@ts-nocheck
import { Registry } from '@react-registry'
import isUrl from 'is-url'

import { wrapLink, handleCursorIfCursorEndOfLink, isVisuallyEqualPoint } from './utils'
import { Editor, Transforms, Range, Path, Element, Node, Text,  } from 'slate'
import { ReactEditor } from 'slate-react';

export const withHyperlinks = (editor) => {
  const { insertData, insertText, isInline, insertBreak, normalizeNode } = editor
  editor.isInline = (element) => {
    return element.type === 'a' ? !element?.attrs?.isBlock : isInline(element)
  }

  editor.insertText = (text) => {
    if (text && isUrl(text)) {
      wrapLink(editor, text)
    } else {
      if (/\s/g.test(text)) {
        const [anchorNode, anchorPath] = Editor.parent(editor, editor.selection)
        if (
          // Move cursor position to the next text node
          Range.isCollapsed(editor.selection) &&
          Editor.isEnd(editor, editor.selection.focus, anchorPath) &&
          (anchorNode.type === 'a' || anchorNode?.attrs?.['display-type'] === 'link')
        ) {
          Transforms.move(editor, { distance: 1, unit: 'offset' })
        }
      }
      insertText(text)
    }
  }

  editor.insertBreak = () => {
    const [selectedElement, path] = Editor.parent(editor, editor.selection);

    if (selectedElement.type === 'a' || selectedElement?.attrs?.['display-type'] === 'link') {
      const endPoint = Range.end(editor.selection);
      const [selectedLeaf] = Editor.node(editor, endPoint);
      //@ts-ignore
      if (selectedLeaf.text.length === endPoint.offset) {
        if (Range.isExpanded(editor.selection)) {
          Transforms.delete(editor);
        }
        // Transforms.select(editor, Path.next(path));
      }
    }
    handleCursorIfCursorEndOfLink(editor, isVisuallyEqualPoint);
    insertBreak();
  };

  editor.insertData = (data) => {
    const text = data.getData('text/plain')

    if (text && isUrl(text)) {
      wrapLink(editor, text)
    } else {
      insertData(data)
    }
  }

  return editor
}

Registry.register(withHyperlinks, { id: 'withHyperlinks', registry: 'plugin' })

